import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  model,
} from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'lassi-lot-search-plan-form',
  imports: [FormsModule, MatFormFieldModule, MatInput, MatDialogModule],
  template: `
    <mat-form-field>
      <mat-label>Lot</mat-label>
      <input
        matInput
        name="lot"
        [(ngModel)]="lot"
        #lotInput="ngModel"
        maxlength="12"
        pattern="^[a-zA-Z0-9\\-]+$"
      />
      <mat-hint>Alphanumeric, max 12 chars (e.g. C2M, RES101)</mat-hint>
      @if (lotInput.hasError('pattern')) {
        <mat-error>Alphanumeric values only</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Plan</mat-label>
      <input
        matInput
        name="plan"
        [(ngModel)]="plan"
        #planInput="ngModel"
        maxlength="9"
        pattern="^[a-zA-Z0-9]+$"
        required
      />
      <mat-hint>Alphanumeric, max 9 chars (e.g. TP956586)</mat-hint>
      @if (planInput.hasError('pattern')) {
        <mat-error>Alphanumeric values only</mat-error>
      }
      @if (planInput.hasError('required')) {
        <mat-error>Plan is required</mat-error>
      }
    </mat-form-field>
    <button type="submit" class="hidden">submit</button>
  `,
  styles: `
    @use 'breakpoints' as *;
    :host {
      margin-top: 0.5rem;
    }

    mat-form-field {
      display: block;
      padding-bottom: 1.25rem;
    }
  `,
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotSearchPlanFormComponent {
  lot = model<string | null>();
  plan = model<string | null>();

  readonly router = inject(Router);
  readonly route = inject(ActivatedRoute);
  readonly destroyRef = inject(DestroyRef);
}
